export const BLOG_NEW_ONBOARDING_FLOW = 'Blog:NewOnboardingFlow'; // Determines group key for CMS free signups
//  - ungated: applies new group key (content_view)
//  - gated: falls back to existing group key logic (cms_free_view*)

export const CONTENT_HUB_ONBOARDING = 'ContentHub-onboarding';